import find from "lodash/find";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { Template } from "PFTypes";
import { useCallback } from "react";

export const useTemplateFind = () => {
  const {
    data: { templates }
  } = useMyAccountInfo();

  return useCallback(
    (attributesToCheck: Partial<Template>) => find(templates, attributesToCheck),
    [templates]
  );
};
